import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderModule } from 'src/app/shared/loader/loader.module';
import { AuthGuardWithForcedLogin } from 'src/app/core/auth/auth-guard-with-forced-login.service';
import { HomeComponent } from './home.component';
import { HSPAPermission } from 'src/app/shared/models/hspa-permission.enum';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    HomeComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    SharedModule,
    RouterModule.forChild([
      {
        path: '',
        canActivate: [AuthGuardWithForcedLogin],
        component: HomeComponent,
      },
    ]),
    ReactiveFormsModule,
    LoaderModule
  ],
  exports: [
  ],
  providers: [
  ]
})
export class HomeModule { }
